// src/version.js
export const version = require("../package.json").version;
